export const mistychnaUkrainaTheme = {
    primary: "#29b978",
    accent: "#da8b37",
    background: "#102025",
    card: "#f2e6cd",
    text: "#20271f",
    mutedText: "#5d625e",
    buttonText: "#ffffff",
    progress: "#45d894",
    border: "#b7b29f",
    radius: "8px",
    fontFamily: "Manrope, ui-sans-serif, system-ui, sans-serif",
    headlineScale: 1,
    bodyScale: 1,
    spacingDensity: "compact",
    answerWeight: 600
};
